import type { Parent } from '@atlassian/jira-filters/src/common/types.tsx';
import type { IssueId, Hash } from '@atlassian/jira-shared-types/src/general.tsx';
import type { Status } from '@atlassian/jira-software-roadmap-model/src/status/index.tsx';
import { createSelectorWithDefaultEqual } from '../../../../../common/utils/reselect/index.tsx';
import {
	getIssueParentIds,
	getIssueSummaryHash,
	getIssueStatusHash,
} from '../../../../entities/issues/selectors.tsx';

export type ParentWithStatus = Parent & {
	status: {
		name: string;
		categoryId: string;
	};
};

export const getIssueParentsWithStatus = createSelectorWithDefaultEqual(
	getIssueParentIds,
	getIssueSummaryHash,
	getIssueStatusHash,
	(
		uniqueIssueParentIds: IssueId[],
		issueSummaryHash: Hash<string>,
		issueStatusHash: Hash<Status | undefined>,
	): ParentWithStatus[] =>
		uniqueIssueParentIds.map((parentId) => ({
			id: parentId,
			name: issueSummaryHash[parentId],
			status: {
				name: issueStatusHash[parentId]?.name || '',
				categoryId: issueStatusHash[parentId]?.statusCategoryId || '',
			},
		})),
);
